export default [
	{
		settings: true,
		text: "ID",
		value: "id",
		func: true,
		valueFilter: 'filter_id',
		model: { value: 'list' },
		sortable: true,
		footer: "unique"
	},
	{
		settings: true,
		text: "Name",
		value: "name",
		func: true,
		valueFilter: 'filter_name',
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "User Group",
		value: "userGroup",
		func: true,
		valueFilter: 'filter_userGroup',
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Customer",
		value: "customer",
		func: true,
		valueFilter: 'filter_customer',
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Dispatcher",
		value: "dispatcher",
		func: true,
		valueFilter: 'filter_dispatcher',
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Email",
		value: "email",
		func: true,
		valueFilter: 'filter_email',
		model: { value: 'list' },
		sortable: true,
		toLeft: true
	},
	{
		settings: true,
		text: "Updated at",
		value: "updated_at",
		func: true,
		valueFilter: 'filter_updated_at',
		model: { value: 'date' },
		sortable: true,
		toLeft: true
	},
	{
		settings: true,
		text: "Status",
		value: "status",
		func: true,
		valueFilter: 'filter_status',
		model: { value: 'list' },
		sortable: true,
		modText: true,
	},
	{
		settings: true,
		width: '100px',
		buttons: [
			{
				perm: { or: [ 9 ] },
				value: 'edit',
				text: 'Edit user',
				icon: { value: 'edit', w: 18, h: 18 },
			},
			{
				perm: true,
				value: 'delete',
				text: 'Delete user',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			},
		]
	},
];
